import { useEffect, useState } from "react";
import { useToast } from "@/hooks/use-toast";

interface UseNetworkStatusOptions {
  onReconnect?: () => void;
  showToasts?: boolean;
}

export function useNetworkStatus({ onReconnect, showToasts = true }: UseNetworkStatusOptions = {}) {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const { toast } = useToast();

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (showToasts) {
        toast({
          title: "Conectado",
          description: "Conexão restaurada - dados atualizados",
          duration: 3000
        });
      }
      if (onReconnect) {
        onReconnect();
      }
    };

    const handleOffline = () => {
      setIsOnline(false);
      if (showToasts) {
        toast({
          title: "Sem conexão",
          description: "Verifique sua conexão de internet",
          variant: "destructive",
          duration: 5000
        });
      }
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [onReconnect, showToasts, toast]);

  return { isOnline };
}